export default __webpack_public_path__ + "static/media/neon-logo-yellow.6542d690.svg";